"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirdropTargetsStruct = exports.AirdropTargetStructList = exports.AirdropTargetStruct = void 0;
const BL = __importStar(require("@solana/buffer-layout"));
const accountParser_1 = require("../common/accountParser");
exports.AirdropTargetStruct = BL.struct([(0, accountParser_1.u64Field)("amount"), (0, accountParser_1.pubkeyField)("recipient")]);
exports.AirdropTargetStructList = BL.seq(exports.AirdropTargetStruct, 10000);
exports.AirdropTargetsStruct = BL.struct([
    (0, accountParser_1.u64Field)("rewardTotal"),
    (0, accountParser_1.u64Field)("recipientsTotal"),
    (0, accountParser_1.u64Field)("finalized"),
    exports.AirdropTargetStructList.replicate("recipients")
]);
console.assert(exports.AirdropTargetStruct.span === 40);
console.assert(exports.AirdropTargetsStruct.span === 400024);
//# sourceMappingURL=layout.js.map